import { useContext } from 'react';
import { createContext } from 'react';

import { ProductGiftsProps } from '../@types/ProductGiftsProps';

export const ProductGiftsContext = createContext<ProductGiftsProps>({} as ProductGiftsProps);

ProductGiftsContext.displayName = 'ProductGifts';

const ProductGiftsProvider = (props: ProductGiftsProps) => (
	<ProductGiftsContext.Provider value={props}>{props.children}</ProductGiftsContext.Provider>
);

export const useProductGifts = () => {
	const context = useContext(ProductGiftsContext);

	return context;
};

export default ProductGiftsProvider;
